import React from "react";
import { Emote as EmoteInterface } from "src/common/interfaces/Emote";
import Emote from "./Emote";
import style from "./EmoteList.module.scss";

interface EmoteListProps {
  emotes: EmoteInterface[];
  onEmoteClick: (emote: EmoteInterface) => void;
  selectedEmote: EmoteInterface | null;
}

const EmoteList: React.FC<EmoteListProps> = ({ emotes, onEmoteClick, selectedEmote }) => {
  return (
    <div className={style.emoteList}>
      {emotes.map((item, index) => {
        return (
          <Emote
            key={index}
            isSelected={item.id === selectedEmote?.id}
            src={item.imageUrl}
            className={style.emoteList__item}
            onClick={() => onEmoteClick(item)}
          />
        );
      })}
    </div>
  );
};

export default EmoteList;
